import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  max-width: 400px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0a1424;
  position: relative;
  z-index: 1000;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
`;

export const Users = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  width: 100%;
  max-height: calc(40px * 10 + 12px * 9);
  padding-right: ${(p) => (p.$padding ? "12px" : "0")};

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 12px;
    background: #325682;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 12px;
  }
`;

export const ProfilePhoto = styled.img`
  width: 26px;
  height: 26px;
  aspect-ratio: 1/1;
  flex-shrink: 0;
  border-radius: 50%;
  border: 0.684px solid #164e95;
`;

export const FollowButton = styled.button`
  display: flex;
  height: 26px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100px;
  border-radius: 100px;
  border: ${(p) => (!p.$isFollowed ? "none" : "1px solid #345884")};
  background: ${(p) => (!p.$isFollowed ? "#fff" : "#142743")};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  color: ${(p) => (p.$isFollowed ? "#fff" : "#060e1a")};
  font-family: Figtree;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.07px;
  cursor: pointer;
  outline: none;
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Name = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  letter-spacing: 0.09px;
`;

export const Username = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  letter-spacing: 0.09px;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 15px;
  opacity: 0.4;
  font-weight: 400;
  line-height: 20px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  outline: none;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;
  color: ${({ $type }) => ($type === "primary" ? "#081120" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

// ── Novi elementi ──────────────────────────────────────────────

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0 4px;
  width: 100%;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  width: 100%;
  gap: 6px;

  span:first-child {
    color: #fff;
    font-family: Figtree;
    font-size: 15px;
    font-weight: 600;
  }

  span:last-child {
    color: #fff;
    opacity: 0.5;
    font-family: Figtree;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
  }
`;

export const FadeOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  pointer-events: none;
  border-radius: 0 0 4px 4px;
  background: linear-gradient(to bottom, transparent, #0a1424);
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transition: opacity 0.3s ease;
`;
